import React, { ReactNode } from 'react'
import Link from 'next/link'
import cn from 'classnames'

interface BreadcrumbItemProps {
    url?: string
    title: string
    active?: boolean
    className?: string
}

export const BreadcrumbItem = ({
    url,
    title,
    active = false,
    className
}: BreadcrumbItemProps): JSX.Element => {
    return (
        <BreadcrumbLink
            href={url}
            linkClass={cn(className, { active: active })}
        >
            {toCamelCase(title)}
        </BreadcrumbLink>
    )
}

type BreadcrumbLinkProps = {
    href?: string
    children: ReactNode
    linkClass?: string
}

const BreadcrumbLink = ({ href, children, linkClass }: BreadcrumbLinkProps) =>
    href ? (
        <Link href={href} className={linkClass}>
            {/* eslint-disable-next-line */}
            {children}
        </Link>
    ) : (
        <span>{children}</span>
    )

const toCamelCase = (string = ' ') =>
    `${(string[0] || '').toUpperCase()}${string.substring(1).toLowerCase()}`
